import type { IconData } from '@stacksjs/iconify-core'

export const manArmRaises2Alternate: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M18 9a6 6 0 1 0 12 0a6 6 0 0 0-12 0\"/><path d=\"m7.018 11.626l9.441 2.926a10 10 0 0 0 2.96.448h9.143a10 10 0 0 0 2.998-.46l9.299-2.922c1.185-.372 2.536 0 3.067 1.123c.715 1.512.709 2.8.514 3.724c-.223 1.065-1.142 1.76-2.144 2.187L32.096 23l-.85 18.266c-.087 1.886-1.483 3.446-3.366 3.587A52 52 0 0 1 24 45c-1.456 0-2.78-.064-3.878-.147c-1.883-.14-3.28-1.701-3.367-3.587L15.905 23l-10.24-4.3c-1.086-.457-2.07-1.232-2.252-2.396c-.14-.894-.102-2.095.51-3.49c.51-1.16 1.885-1.564 3.095-1.188M24 45V32\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default manArmRaises2Alternate
